var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table__body__row__cell",class:'column-size__' + _vm.size},[_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }